
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi créer un site Internet vitrine : 5 raisons !",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous n’avez pas encore votre site Internet ? Cet article vous donne 5 bonnes raisons de franchir le pas !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi créer un site Internet vitrine : 5 raisons !",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous n’avez pas encore votre site Internet ? Cet article vous donne 5 bonnes raisons de franchir le pas !",
        },
      ],
    };
  },
};
